// @ts-ignore
import Cleave from 'cleave.js/dist/cleave-react';
import { forwardRef } from 'react';

function assignRef<T>(ref: React.Ref<T> | undefined, value: T) {
  if (typeof ref === 'function') {
    ref(value);
    return;
  }

  if (ref) {
    ref.current = value;
  }
}

export const CleaveTime = forwardRef<HTMLInputElement, any>((props, ref) => {
  const { inputRef, onBlur, value, onChange, ...rest } = props;

  const handleHtmlRef = (node: HTMLInputElement | null) => {
    assignRef(ref, node);
    assignRef(inputRef, node);
  };

  return (
    <Cleave
      htmlRef={handleHtmlRef}
      options={{
        time: true,
        timePattern: ['h', 'm'],
      }}
      onChange={onChange}
      value={value}
      {...rest}
      onBlur={(e: any) => {
        const { value } = e.target;
        if (rest.onChange && value.length && value.length < 5) {
          const val = value.split(':');
          e.target.value = [val[0] + '00', `${val[1] || ''}00`]
            .map((item) => item.slice(0, 2))
            .join(':');
          rest.onChange(e);
        }
        if (onBlur) onBlur(e);
      }}
    />
  );
});

CleaveTime.displayName = 'CleaveTime';
